<template lang="pug">
.app-login-modal(:class="{visible}")
  .app-login-modal-mask
  .app-login-modal-box
    img.button-close(src="@/assets/common/icon-close.svg"
      @click="handleClose")
    template(v-if="showType === 'signIn'")
      .login-tab-container
        .login-tab-item(:class="{'active': loginTab.currentSymbol === 'account'}"
          @click="handleLoginTabChange('account')") 账号登录
        .login-tab-divider
        .login-tab-item(:class="{'active': loginTab.currentSymbol === 'phone'}"
          @click="handleLoginTabChange('phone')") 手机快捷登录
      .login-input-container(:class="[loginTab.currentSymbol]")
        template(v-if="loginTab.currentSymbol === 'account'")
          .login-input-wrapper
            input(placeholder="输入手机号" v-model="loginForm.username")
          .login-input-wrapper
            input(placeholder="输入密码" type="password" v-model="loginForm.password")
        template(v-if="loginTab.currentSymbol === 'phone'")
          .login-input-wrapper
            input(placeholder="输入手机号" v-model="mobileForm.username")
          .login-input-wrapper
            input(placeholder="输入验证码" maxlength="4" v-model="mobileForm.code")
            img.captcha(:src="verify.url" @click="loadVerify")
          .login-input-wrapper
            input(placeholder="输入验证码")
            .send-captcha.finger(@click="sendCaptcha") {{ captcha.text }}
        .button-login(:class="{'loading': loginLoading, 'logged': logged}"
          @click="handleLogin")
          i.el-icon-loading(v-if="loginLoading")
          | {{ logged ? '已登录' : '登录' }}
        .auth-container
          .remember
            input(type="checkbox")
            | 记住我
          .account
            .account-item.forgot.finger
              | 忘记密码
              i.el-icon-arrow-right
            .account-item.register
              span 还没有账号？
              span.button-sign-up.finger(@click="handleShowTypeChange('signUp')")
                | 点击注册
                i.el-icon-arrow-right
        //.third-container
          .tip 使用第三方账号登录
    template(v-if="showType === 'signUp'")
      .login-title-container
        .button-back(@click="showType = 'signIn'")
          i.el-icon-arrow-left
        .title 账号注册
      .login-input-container
        .login-input-wrapper
          input(placeholder="输入手机号" v-model="registerForm.username")
        .login-input-wrapper
          input(placeholder="输入密码" v-model="registerForm.password" type="password")
        .login-input-wrapper
          input(placeholder="输入验证码" maxlength="4" v-model="verifyForm.imgCode")
          img.captcha(:src="verify.url" @click="loadVerify")
        .login-input-wrapper
          input(placeholder="手机验证码" v-model="registerForm.code")
          .send-captcha.finger(@click="sendCaptcha") {{ captcha.text }}
        .button-login(:class="{'loading': registerLoading}"
          @click="handleRegister")
          i.el-icon-loading(v-if="registerLoading")
          | 注册
        .auth-container.center
          .account
            .account-item.register
              span 已有账号？
              span.button-sign-up.finger(@click="handleShowTypeChange('signIn')")
                | 点击登录
                i.el-icon-arrow-right
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import _ from 'lodash';
import axios from "axios";

export default {
  name: "AppLoginModal",
  data() {
    return {
      visible: false,
      showType: 'signIn',
      loginTab: {
        currentSymbol: 'account',
      },
      loginForm: {
        username: process.env.NODE_ENV === 'development' ? '18788115543' : '',
        password: process.env.NODE_ENV === 'development' ? '123456': '',
      },
      mobileForm: {
        username: '',
        code: ''
      },
      registerForm: {
        username: '',
        password: '',
        code: ''
      },
      verifyForm: {
        imgCode: '',
      },
      loginLoading: false,
      registerLoading: false,
      verify: {
        url: '',
      },
      captcha: {
        text: '发送验证码',
        time: 0,
        timer: null,
      },
      intent: {
        successTip: '登录成功',
        method: '',
        params: {},
      },
    }
  },
  computed: {
    ...mapGetters({
      logged: 'auth/logged',
    }),
  },
  methods: {
    ...mapActions({
      signIn: 'auth/signIn',
      signUp: 'auth/signUp',
      mobileAuth: 'auth/mobileAuth',
      getCaptcha: 'auth/getCaptcha',
      queryVerify: 'auth/verify',
      queryUserInfo: 'auth/queryUserInfo',
    }),
    $open(showType, intent = { method: '', params: {}, successTip: '登录成功' }) {
      this.showType = showType;
      this.visible = true;
      if(this.showType === 'signUp' || this.loginTab.currentSymbol === 'phone') {
        this.loadVerify();
      }
      if(!_.isEmpty(intent.method)) {
        this.intent = {...intent};
      }
    },
    handleShowTypeChange(type) {
      this.showType = type;
      if(type === 'signUp') {
        this.loadVerify();
      }
    },
    handleLoginTabChange(symbol) {
      this.loginTab.currentSymbol = symbol;
      if(symbol === 'phone') {
        this.loadVerify();
      }
    },
    handleClose() {
      this.visible = false;
      if(!_.isEmpty(this.intent.method)) {
        this.$emit('success', this.intent);
        Object.assign(this.$data.intent, this.$options.data().intent);
      }
    },
    loadVerify() {
      axios.request({
        url: `/api/user/verify?random=${_.random(100, 999)}`,
        method: 'post',
        responseType: 'blob'
      }).then(res => {
        const blob = new Blob([res.data], {
          type: 'application/png;charset=utf-8',
        });
        this.verify.url = window.URL.createObjectURL(blob);
      });
    },
    checkLoginParams() {
      if(this.loginTab.currentSymbol === 'account') {
        const { username, password } = this.loginForm;
        if(_.isEmpty(username)) {
          this.$message.error(`请输入手机号码`);
          return false;
        }
        if(_.isEmpty(password)) {
          this.$message.error(`请输入密码`);
          return false;
        }
      }
      if(this.loginTab.currentSymbol === 'phone') {
        const { username, code } = this.mobileForm;
        if(_.isEmpty(username)) {
          this.$message.error(`请输入手机号码`);
          return false;
        }
        if(_.isEmpty(code)) {
          this.$message.error(`请输入手机验证码`);
          return false;
        }
      }
      return true;
    },
    async handleLogin() {
      if(this.loginLoading || this.logged) return false;
      if(this.checkLoginParams()) {
        this.loginLoading = true;
        if(this.loginTab.currentSymbol === 'account') {
          const {code} = await this.signIn(this.loginForm);
          if(code === 1) {
            await this.queryUserInfo();
            this.$message.success(this.intent.successTip);
            setTimeout(() => {
              this.handleClose();
            }, 2500);
          } else {
            this.$message.error('登录失败');
          }
        }
        if(this.loginTab.currentSymbol === 'phone') {
          const {code} = await this.mobileAuth(this.mobileForm);
          if(code === 1) {
            await this.queryUserInfo();
            this.$message.success(this.intent.successTip);
            setTimeout(() => {
              this.handleClose();
            }, 2500);
          } else {
            this.$message.error('登录失败');
          }
        }
        this.loginLoading = false;
      }
    },
    checkRegisterParams() {
      const { username, password, code } = this.registerForm;
      if(_.isEmpty(username)) {
        this.$message.error(`请输入手机号码`);
        return false;
      }
      if(_.isEmpty(password)) {
        this.$message.error(`请输入密码`);
        return false;
      }
      if(_.isEmpty(code)) {
        this.$message.error(`请输入手机验证码`);
        return false;
      }
      return true;
    },
    async handleRegister() {
      if(this.checkRegisterParams()) {
        this.registerLoading = true;
        const {code} = await this.signUp(this.registerForm);
        if(code === 1) {
          this.loginForm.username = this.registerForm.username;
          this.loginForm.password = this.registerForm.password;
          await this.handleLogin();
        }
        this.registerLoading = false;
      }
    },
    resetCaptcha() {
      this.captcha.text = '发送验证码';
      clearInterval(this.captcha.timer);
      this.captcha.time = 0;
      this.captcha.timer = null;
    },
    checkCaptchaParams(mobile) {
      if(_.isEmpty(mobile)) {
        this.$message.error(`请输入手机号码`);
        return true;
      }
      if(_.isEmpty(this.verifyForm.imgCode)) {
        this.$message.error(`请输入图形验证码`);
        return true;
      }
      return false;
    },
    async sendCaptcha() {
      if(this.captcha.timer === null) {
        const mobile = this.showType === 'signIn' ? this.mobileForm.username : this.registerForm.username;
        if(this.checkCaptchaParams(mobile)) return false;
        const {code} = await this.getCaptcha({
          imgCode: this.verifyForm.imgCode,
          mobile,
        });
        if(code === 1) {
          this.$message.success(`验证码已发送至${mobile}，请注意查收`);
          this.captcha.time = 60;
          this.captcha.text = `${this.captcha.time}s后重新发送`;
          this.captcha.timer = setInterval(() => {
            this.captcha.time -= 1;
            this.captcha.text = `${this.captcha.time}s后重新发送`;
            if(this.captcha.time < 1) {
              this.resetCaptcha();
            }
          }, 1000);
        } else {
          this.$message.error(`验证码发送失败，请稍后再试`);
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.app-login-modal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  visibility: hidden;
  pointer-events: none;
  &.visible{
    visibility: visible;
    pointer-events: auto;
    .app-login-modal-mask{
      background-color: rgba(0, 0, 0, .5);
    }
    .app-login-modal-box{
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }
  .app-login-modal-mask{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0);
    backdrop-filter: blur(10px);
    transition: .2s ease;
  }
  .app-login-modal-box{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(.25);
    background-color: white;
    padding: 32px 56px;
    border-radius: 24px;
    opacity: 0;
    transition: .2s ease;
    .button-close{
      position: absolute;
      top: 20px;
      right: 20px;
      @extend .finger;
    }
    .login-title-container{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 38px;
      .button-back{
        @include circular(22px);
        background: #878C99;
        @extend .flex-center;
        color: white;
        @extend .finger;
      }
      .title{
        padding-left: 18px;
        font-weight: 700;
        font-size: 20px;
        color: #878C99;
      }
    }
    .login-tab-container{
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 32px;
      .login-tab-item{
        font-weight: 700;
        font-size: 20px;
        color: #878C99;
        @extend .finger;
        height: 42px;
        line-height: 42px;
        transition: .15s ease;
        position: relative;
        &:after{
          content: '';
          display: block;
          background: rgba(0, 119, 57, 0);
          border-radius: 2px;
          @include size(40px, 4px);
          position: absolute;
          left: 50%;
          bottom: 50%;
          transform: translate(-50%, -50%);
          transition: .15s ease;
        }
        &.active{
          color: #007739;
          line-height: 26px;
          &:after{
            background: #007739;
            bottom: 0;
          }
        }
      }
      .login-tab-divider{
        @include size(1px, 15px);
        margin: 0 30px;
        background-color: #D5DAE5;
      }
    }
    .login-input-container{
      transition: .15s ease;
      &.account{
        height: 300px;
      }
      &.phone{
        height: 370px;
      }
      .login-input-wrapper{
        @include size(368px, 50px);
        border: 1px solid #D5DAE6;
        border-radius: 8px;
        display: flex;
        align-items: center;
        & + .login-input-wrapper{
          margin-top: 14px;
        }
        input{
          flex: 1;
          border: none;
          outline: none;
          display: block;
          @include square(100%);
          padding: 0 0 0 14px;
          background-color: transparent;
        }
        .captcha{
          @include size(122px, 34px);
          margin-right: 20px;
        }
        .send-captcha{
          font-size: 14px;
          color: #878C99;
          border-left: 1px solid #D5DAE5;
          padding-left: 12px;
          padding-right: 20px;
        }
      }
      .button-login{
        margin-top: 24px;
        @include size(368px, 50px);
        background: #007739;
        border-radius: 8px;
        color: white;
        @extend .flex-center;
        @extend .finger;
        font-size: 16px;
        &.loading,
        &.logged{
          position: relative;
          &:before{
            content: '';
            position: absolute;
            @include square(100%);
            background-color: rgba(255, 255, 255, 0.35);
          }
        }
        &.logged{
          cursor: not-allowed;
        }
        i{
          margin-right: 8px;
        }
      }
      .auth-container{
        padding-top: 16px;
        padding-bottom: 60px;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #878C99;
        .remember{
          display: flex;
          input{
            margin-right: 8px;
          }
        }
        &.center{
          justify-content: center;
          padding-bottom: 0;
        }
        .account{
          display: flex;
          .account-item{
            & + .account-item{
              margin-left: 12px;
            }
            .button-sign-up{
              color: #007739;
            }
          }
        }
      }
      .third-container{
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #878C99;
      }
    }
  }
}
</style>
